<template>
  <div class="main">
    <Header-list ref="header" v-if="$route.meta.content!=='注册'"/>
    <div id="renderBody">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
    <Footer-list ref="footer"/>
    <register-panel ref="register"></register-panel>
    <div class="scroll-to-top" @click="scrollToTop(0.1)" v-show="toTopBtnShow">
      <!--      <div class="text">顶部</div>-->
      <!--      <div class="icon"><i class="iconfont icon-back-top"></i></div>-->
      <img src="../assets/img/index/return-top.svg" alt="回到顶部">
    </div>
  </div>
</template>
<script>
import HeaderList from './common/header.vue'
import FooterList from './common/footer.vue'
import RegisterPanel from './common/registerPanel.vue'
import footerCodes from '../../static/js/staticFooterCode'

export default {
  inject: ['reload', 'goSelf'],
  provide () {
    return {
      openRegister: this.openRegister
    }
  },
  data () {
    return {
      toTopBtnShow: false,
      defaultHeight: 250
    }
  },
  methods: {
    openRegister (bool, sourceCode, currentCodes) {
      console.log(currentCodes)
      const sourceId = this.$route.name
      let code = sourceCode || ''
      let currentCode = currentCodes || ''
      let footerCode = footerCodes.filter((item) => {
        return item.id === sourceId
      }) || ''
      if (sourceCode.includes('footer')) {
        if (footerCode[0].code === 'solution') {
          code = (footerCode[0].code + '-' + currentCodes + '-' + sourceCode) || ''
        } else {
          code = (footerCode[0].code + '-' + sourceCode) || ''
        }
      }
      if (!sourceId) {
        this.$refs.register.openDialog(bool, code)
      } else {
        let routeUrl = this.$router.resolve({
          name: 'Register',
          query: {
            sourceId,
            currentCode,
            code
          }
        })
        window.open(routeUrl.href, '_blank')
      }
    },
    scrollToTop (acceleration, stime) {
      acceleration = acceleration || 0.1
      stime = stime || 10
      let y1 = 0
      let y2 = 0
      let y3 = 0
      if (document.documentElement) {
        y1 = document.documentElement.scrollTop || 0
      }
      if (document.body) {
        y2 = document.body.scrollTop || 0
      }
      y3 = window.scrollY || 0
      let y = Math.max(y1, Math.max(y2, y3))
      let speeding = 1 + acceleration
      window.scrollTo(0, Math.floor(y / speeding))
      if (y > 0) {
        window.setTimeout(() => {
          this.scrollToTop(acceleration, stime)
        }, stime)
      }
    },
    handleScrollT () {
      let osTop = document.documentElement.scrollTop || document.body.scrollTop
      if (osTop >= this.defaultHeight) {
        this.toTopBtnShow = true
      } else {
        this.toTopBtnShow = false
      }
    }
    // goBack () {
    //   if (this.$route.name === 'ClienteleDetile') {
    //     this.$router.go(-1)
    //   }
    // }
  },
  created () {
  },
  mounted () {
    this.defaultHeight = document.documentElement.clientHeight
    let _this = this
    window.addEventListener('scroll', _this.handleScrollT)
    let TabDom = document.getElementsByClassName('el-tabs__nav is-top')
    for (let i = 0; i < TabDom.length; i++) {
      TabDom[i].addEventListener('keydown', (e) => {
        e.stopPropagation()
        return false
      }, true)
    }
  },
  updated () {
    this.$refs.footer.checkFooter(this.$route.name)
  },
  components: {
    HeaderList,
    FooterList,
    RegisterPanel
  }
}
</script>

<style lang="scss">
  @import '../../static/css/common.scss';
  @import '../../static/fonts/iconfont.css';
  @import '../../static/css/reset.css';

  #renderBody {
    min-width: 1200px;
  }
</style>



// WEBPACK FOOTER //
// layout.vue?7167b25a